module.exports = __webpack_public_path__ + "img/zhibo.25052df3.png";